import React from "react";
import { User } from "../../../service";
import ReusableForm from "../ReusableForm";
import { Toaster, toast } from "react-hot-toast";
import AuthBgImage from "assets/images/auth_bg.jpg";
import { useNavigate, useLocation } from "react-router-dom";
import { formFieldsForgetPassword } from "../../constant/Home/Authentication";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const token = new URLSearchParams(search).get("token");

  const handleResetRequest = async (values, { setSubmitting }) => {
    const loadingToastId = toast.loading("loading");
    try {
      await User.requestPasswordReset(values);
      toast.success("Reset link sent successfully!");
    } catch (error) {
      console.log(error, "error");
      toast.error(error?.response?.data?.error || "Failed to send reset link");
    } finally {
      setSubmitting(false);
      toast.dismiss(loadingToastId);
    }
  };

  const handlePasswordReset = async (values, { setSubmitting }) => {
    try {
      await User.confirmPasswordReset({
        password: values.password,
        token_key: token,
      });
      toast.success("Password reset successfully!");
      navigate("/login");
    } catch (error) {
      toast.error(error || "Failed to reset password");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center bg-no-repeat p-4 md:p-6 lg:p-8 flex items-center justify-center relative"
      style={{ backgroundImage: `url(${AuthBgImage})` }}
    >
      {/* Overlay div */}
      <Toaster />
      <div
        className="absolute inset-0 bg-black"
        style={{ backgroundColor: "#00000033" }}
      />

      <div className="flex flex-col rounded-[20px] p-4 md:p-6 lg:p-8 w-full max-w-[600px] justify-center items-center bg-white z-10">
        <div className="w-full">
          {!token ? (
            <ReusableForm
              title="Trouble Logging In?"
              description="No worries — enter your email address below and we'll send you a link to reset your password."
              initialValues={{ email: "" }}
              fields={formFieldsForgetPassword.resetRequest}
              handleClick={handleResetRequest}
              submitButtonText="Send Reset Link"
            >
              <p className="text-center text-[14px] text-[#767676] tracking-[0.025em] font-medium leading-6">
                Remember your password?{" "}
                <span
                  className="text-[#2C8D48] cursor-pointer"
                  onClick={() => navigate("/login")}
                >
                  Login
                </span>
              </p>
            </ReusableForm>
          ) : (
            <ReusableForm
              title="Reset Password"
              description="Enter your new password."
              initialValues={{ password: "", confirmPassword: "" }}
              fields={formFieldsForgetPassword.passwordReset}
              handleClick={handlePasswordReset}
              submitButtonText="Reset Password"
              className="space-y-4 w-full"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
